import SoftSkillsChart from "./SoftSkillsChart";
import useQueryInsightMostInDemandSoftSkills from "./useQueryInsightMostInDemandSoftSkills";
import WaitForData from "../../common/data-fetching/WaitForData";
import Loader from "../../common/loading-widgets/Loader";
import SkeletonBarChart from "./SkeletonBarChart";

const SoftSkillsCard = (props) => {
  const { keyword, language, chartColor, displayLegend, insightCount } = props;

  const {
    loading,
    errors,
    data: softSkillsData,
  } = useQueryInsightMostInDemandSoftSkills(keyword, 15, language);

  return (
    <div className="widget-block">
      <Loader icon={<SkeletonBarChart />}>
        <WaitForData
          loading={loading}
          errors={errors}
          onLoaded={() => (
            <SoftSkillsChart
              keyword={keyword}
              softSkillsData={softSkillsData}
              chartColor={chartColor}
              displayLegend={displayLegend}
              insightCount={insightCount}
            />
          )}
        />
      </Loader>
    </div>
  );
};

export default SoftSkillsCard;
